import type { User, AvailabilityConfig } from '@/types';

export type StepId =
  | 'company'
  | 'logo'
  | 'agreement'
  | 'booking'
  | 'payment'
  | 'spectora'
  | 'done';

export interface StepDefinition {
  id: StepId;
  label: string;
  /** Short helper text under the step label in the sidebar. */
  hint?: string;
  /** Whether this step can be skipped without saving. The final "done" step is never skippable. */
  skippable: boolean;
}

export const STEPS: StepDefinition[] = [
  { id: 'company',  label: 'Your business',     hint: 'Name, phone, license',           skippable: true  },
  { id: 'logo',     label: 'Logo',              hint: 'Appears on reports and emails',  skippable: true  },
  { id: 'agreement',label: 'Pre-inspection agreement', hint: 'Your standard contract',  skippable: true  },
  { id: 'booking',  label: 'Booking page',      hint: 'Slug + weekly availability',     skippable: true  },
  { id: 'payment',  label: 'Payments',          hint: 'Your payment link (optional)',   skippable: true  },
  { id: 'spectora', label: 'Spectora import',   hint: 'Reuse your existing template',   skippable: true  },
  { id: 'done',     label: "You're ready",      hint: 'Create your first inspection',   skippable: false },
];

export interface WizardState {
  profile: User;
  availability: AvailabilityConfig;
}
